var React = require('react');

function FlagAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 30.83v301.29a31.39 31.39 0 0 1-18.5 28.8C317.7 437.33 281.7 291.83 96 384V32.42c209.4-94.59 195.3 59.1 366.6-28.19 22.6-11.5 49.4 1.5 49.4 26.6z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 32v464a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V32a32 32 0 0 1 64 0z","className":"fa-primary","key":2})]);
}

FlagAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = FlagAlt;

FlagAlt.default = FlagAlt;
